import { AuthConfig } from 'angular-oauth2-oidc';

const SCOPES = [
  'openid',
  'tesouraria-plataformaatacado.read',
  'servicocontratacao-negociacaocambiobff.read',
  'servicocontratacao-negociacaocambiobff.write',
  'termosatacado-termosatacado.read',
  'termosatacado-termosatacado.write',
  'gestaoconteudo-tesouraria.read',
  'tesouraria-negderivativos-admin.read',
  'cambio-itautrader.read',
  'cambio-itautrader.write'
].join(' ');

export const environment = {
  production: true,
  apiKey: 'be18d311-a8b2-4ba6-8ec3-b654f1870804',
  fullstoryOrgId: 'o-23254N-na1',
  charonEntrypoint: 'https://apicd.cloud.itau.com.br/charon/i1dnxwfe',
  caronte: {
    '/as/token.oauth2': 'https://apicd.cloud.itau.com.br/charon/es2token',
    '/as/revoke_token.oauth2': 'https://apicd.cloud.itau.com.br/charon/es2revoke'
  },
  ciamAppBanklineAuth: {
    redirectUri: window.location.origin + '/callback/ciam',
    clientId: 'dc-o8kjqwrgbgf4lihnenfcpgdae',
    issuer: 'https://id.itau.com.br',
    responseType: 'code',
    scope: SCOPES,
    disablePKCE: true,
    disableOAuth2StateCheck: true,
    clearHashAfterLogin: true,
    logoutUrl: 'https://apicd.cloud.itau.com.br/charon/es2revoke'
  } as AuthConfig,
  ciamAuth: {
    redirectUri: window.location.origin + '/callback/ciam',
    clientId: 'dc-9q2840etvp3py3c1a7hgt51b8',
    issuer: 'https://id.itau.com.br',
    responseType: 'code',
    scope: SCOPES,
    clearHashAfterLogin: true,
    logoutUrl: 'https://apicd.cloud.itau.com.br/charon/es2revoke'
  } as AuthConfig,
  isamAuth: {
    redirectUri: window.location.origin + '/callback/isam',
    clientId: 'TOvJYTXXx3wVGWXib5OF',
    issuer: 'https://login.itau',
    responseType: 'code',
    scope: 'groups name uname userid',
    clearHashAfterLogin: true
  } as AuthConfig,
  azureAdAuth: {
    redirectUri: window.location.origin + '/callback/azuread',
    clientId: '166b1063-955e-4937-bd89-ffe8d80ce355',
    issuer: 'https://login.microsoftonline.com/591669a0-183f-49a5-98f4-9aa0d0b63d81/v2.0',
    responseType: 'code',
    scope:
      'api://166b1063-955e-4937-bd89-ffe8d80ce355/servicocontratacao-negociacaocambiobff.read api://166b1063-955e-4937-bd89-ffe8d80ce355/openid api://166b1063-955e-4937-bd89-ffe8d80ce355/termosatacado-termosatacado.write api://166b1063-955e-4937-bd89-ffe8d80ce355/tesouraria-negderivativos-admin.read api://166b1063-955e-4937-bd89-ffe8d80ce355/gestaoconteudo-tesouraria.read api://166b1063-955e-4937-bd89-ffe8d80ce355/termosatacado-termosatacado.read api://166b1063-955e-4937-bd89-ffe8d80ce355/tesouraria-plataformaatacado.read api://166b1063-955e-4937-bd89-ffe8d80ce355/servicocontratacao-negociacaocambiobff.write',
    clearHashAfterLogin: true,
    strictDiscoveryDocumentValidation: false,
    skipIssuerCheck: true,
    oidc: true
  } as AuthConfig,
  mayaKey: '6d531acddcb2d344af538f42d9864616',
  
  gtm: 'GTM-NCPMQQJ',
  ga4CdnUrl: 'https://www.itau.com.br/sdk-analytics/index.js',
  ga4Business: 'pj',
  ga4BusinessChannel: 'itau-trader',
  ga4ImplementationTeam: 'experiencia-clientes:produto-derivativos',
  
  quickWebLogger: {
    name: 'PT6-Front-Shell',
    version: '0.61.1',
    env: 'prod',
    sigla: 'PT6',
    externalApplication: true,
    datadog: {
      logs: {
        clientToken: 'puba9262fec4f174ff692ac189e588dec2d',
        sessionSampleRate: 100
      },
      rum: {
        sessionSampleRate: 100,
        applicationId: 'ddfa323c-f094-426e-8693-57c60fb082cf',
        clientToken: 'puba9262fec4f174ff692ac189e588dec2d',
        maskSensitiveData: true,
        allowedTracingUrls: ['https://apicd.cloud.itau.com.br/'],
        traceSampleRate: 100,
        trackUserInteraction: true,
        trackResources: true,
        trackLongTasks: true
      }
    }
  }
};
